const navbar_tr ={
    about: "Hakkımızda",
    industrial_services: "Endüstriyel Hizmetler",
    marine_services: "Denizcilik Hizmetleri",
    solutions: "Çözümler",
    laserCut: "Lazer Kesim",
    machining: "Talaşlı imalat ",
    contact: "İletişim",

    services_overview: "General information",

    stainless_steel_boiler: "Serpantinli Paslanmaz Çelik Boyler İmalatı",
    elec_panel: "Elektrik Panoları ve Kablo Taşıma Sistemleri",
    steel_construction: "Çelik Konstrüksiyon İmalatı",
    storage_tanks: "Depolama Tankları İmalatı",
    carbon_coal_filters: "Karbon ve Kömür Tutucu Sistemler",


    ship_deck_equipment: "Gemi Güverte Teçhizatı İmalat ve Bakımı",
    ship_machinery_equipment:"Gemi Makine Ekipmanları ve Bakımı",
    ship_piping_hydraulic_systems: "Gemi Boru Devreleri ve Hidrolik Sistemler",
    condenser_heat_exchangers: "Kondenser ve Shell & Tube Isı Değiştirici İmalat ve Onarımı",
    ship_steel_construction: "Gemi Çelik Konstrüksiyon İmalatı",
}

const navbar_en ={
    about: "About",
    industrial_services: "Industrial Services",
    marine_services: "Marine Services",
    solutions: "Solutions",
    laserCut: "Laser Cutting",
    machining: "Machining ",
    contact: "Contact",

    services_overview: "General information",

    stainless_steel_boiler: "Manufacturing of Stainless Steel Coil Boilers",
    elec_panel: "Electrical Panels and Cable Tray Systems",
    steel_construction: "Steel Construction Manufacturing",
    storage_tanks: "Storage Tank Manufacturing",
    carbon_coal_filters: "Carbon and Coal Filtration Systems",


    ship_deck_equipment: "Ship Deck Equipment Manufacturing and Maintenance",
    ship_machinery_equipment: "Ship Machinery Equipment",
    ship_piping_hydraulic_systems: "Ship Piping Systems and Hydraulic Systems",
    condenser_heat_exchangers: "Condenser and Shell & Tube Heat Exchanger Manufacturing and Repair",
    ship_steel_construction: "Ship Steel Construction Manufacturing",
}


module.exports = { navbar_tr, navbar_en }